"use strict";
var Observable_1 = require('../../Observable');
var startWith_1 = require('../../operator/startWith');
Observable_1.Observable.prototype.startWith = startWith_1.startWith;
//# sourceMappingURL=startWith.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/startWith.js